import React from 'react';
export function SearchIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.694 20.307l-6.239-6.258A7.495 7.495 0 009.515 2H9.5a7.5 7.5 0 104.535 13.465l6.24 6.259a1.001 1.001 0 001.416-1.413l.003-.004zM5.609 13.38A5.5 5.5 0 019.5 4h.009a5.5 5.5 0 11-3.9 9.384v-.004z"
  }));
}